import script from "./Sula-Webshop.vue?vue&type=script&setup=true&lang=js"
export * from "./Sula-Webshop.vue?vue&type=script&setup=true&lang=js"

import "./Sula-Webshop.vue?vue&type=style&index=0&id=69bf4412&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bf4412"]])

export default __exports__